import React from 'react'

import StatusContratoFormPageContainer from './StatusContratoFormPageContainer'

export class StatusContratoFormPage extends React.Component {
  render() {
    return <StatusContratoFormPageContainer {...this.props} />
  }
}
